import { useQuery, UseQueryOptions } from 'react-query';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import getPaymentOptions, {
  GetPaymentOptionResponse,
} from '@app/store/transport-layer/payment/paymentOptions';

function usePaymentOptions(options?: UseQueryOptions<GetPaymentOptionResponse | null>) {
  const workspaceId = useWorkspaceId();

  return useQuery<GetPaymentOptionResponse | null>(
    ['paymentOption'],
    () => getPaymentOptions(workspaceId),
    options
  );
}

export default usePaymentOptions;
